export default "__VITE_ASSET__ClOXDml0__"